import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tbId = 0,
    ...data
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.save}/${tbId}`, {
        ...data,
    }, options);
    if (error) return { error, status };
    return content || {};
};
